import type { IYmaps } from './types';

/** Адрес и ключи — как у монолита (`YMAPS_URL`, `YMAPS_KEY_COMMERCIAL`, `YMAPS_SUGGEST_KEY_COMMERCIAL`) */
const SCRIPT_URL = 'https://enterprise.api-maps.yandex.ru/2.1/';

export interface IYmapsKeys {
  apiKey: string;
  suggestApiKey: string;
}

let scriptPromise: Promise<IYmaps> | null = null;

const loadScript = ({ apiKey, suggestApiKey }: IYmapsKeys): Promise<IYmaps> =>
  new Promise((resolve, reject) => {
    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const script = document.createElement('script');
    const query = new URLSearchParams({ apikey: apiKey, suggest_apikey: suggestApiKey, lang: 'ru-RU', load: 'Map' });

    script.src = `${SCRIPT_URL}?${query}`;
    script.async = true;
    script.onload = () => (window.ymaps ? resolve(window.ymaps) : reject(new Error('Yandex Maps API is not defined')));
    script.onerror = () => reject(new Error('Unable to load Yandex Maps API'));
    document.body.appendChild(script);
  });

/**
 * Загружает Yandex Maps JS API 2.1 и нужные модули — порт `utils/ymaps.ts` монолита.
 * Скрипт подключается один раз; после ошибки загрузки следующий вызов пробует снова
 */
export async function loadYmapsApi(keys: IYmapsKeys, modules: string[]): Promise<IYmaps> {
  if (!scriptPromise) {
    scriptPromise = loadScript(keys).catch(error => {
      scriptPromise = null;
      throw error;
    });
  }

  const ymaps = await scriptPromise;

  return new Promise((resolve, reject) => {
    ymaps.ready({ require: modules, successCallback: () => resolve(ymaps), errorCallback: reject });
  });
}

/** Для тестов: забыть загруженный скрипт */
export function resetYmapsApi(): void {
  scriptPromise = null;
}
